import { render, staticRenderFns } from "./KnowledgeSourceCard.vue?vue&type=template&id=46455b2d&scoped=true"
import script from "./KnowledgeSourceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeSourceCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KnowledgeSourceCard.vue?vue&type=style&index=0&id=46455b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46455b2d",
  null
  
)

export default component.exports